import { TRPCClientError } from '@trpc/client';

/** tRPC 오류의 서버 코드(data.code, 예: CONFLICT). TRPCClientError 가 아니거나 코드가 없으면 null. */
export const getTrpcErrorCode = (error: unknown): string | null => {
  if (!(error instanceof TRPCClientError)) {
    return null;
  }

  const data = error.data as { code?: unknown } | undefined;
  return typeof data?.code === 'string' ? data.code : null;
};
